import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M18 13a6 6 0 1 0 -6 6","key":"svg-0"}],["path",{"d":"M6 19h12","key":"svg-1"}],["path",{"d":"M10 5v7","key":"svg-2"}],["path",{"d":"M14 12v-7","key":"svg-3"}]]

const IconCurrencyLari = createReactComponent('outline', 'currency-lari', 'CurrencyLari', __iconNode);

export default IconCurrencyLari;